import bundles from './bundles.json';
import {groupRows, capacityRows, cardRows} from './bundleLogic';
export {bundles};
export const statusLabel = status => ({included:'Ingår',addon:'Kan köpas till',partial:'Se detaljer',unavailable:'Ingår inte'})[status];
export function isCurrentPlanOffer(plan, entitlements, cycle) {
    const accepted = entitlements?.items?.find(item => item.kind === 'base_plan');
    const price = plan.billing_prices?.find(item => item.billingCycle === cycle);
    return !!accepted && accepted.versionId === plan.offer_version_id && accepted.code === plan.plan_name
        && accepted.cycle === cycle && !!price
        && (price.versionId ? accepted.priceVersionId === price.versionId : accepted.amountMinor === price.amountMinor);
}
export function termsForPlan(plan) {
    let features = plan.features || plan.payload?.features || {};
    if (typeof features === 'string') { try { features = JSON.parse(features); } catch (_) { features = {}; } }
    const limits = plan.limits || plan.payload?.limits || Object.fromEntries([
        ['maxUsers','max_users'],['maxEmployees','max_employees'],['maxStorageGb','max_storage_gb'],['maxBankAccounts','max_bank_accounts'],
    ].map(([key,column])=>[key,plan[column]]));
    return {features,limits};
}
export function presentPlan(plan, definitions, offers = [], cycle = 'monthly') {
    const {features,limits}=termsForPlan(plan);
    const groups=groupRows(bundles,features,definitions,offers,cycle,'sv');
    return {groups,highlights:cardRows(bundles,groups),capacities:capacityRows(bundles,features,limits,definitions,'sv')};
}
